import styled from "styled-components";
import { Loader } from 'semantic-ui-react';

export const Container = styled.div`
  padding: 1rem 4rem 5rem;
  h1 {
    width: 100%;
    text-align: center;
  }
  h2 {
    text-align: left;
    width: 100%;
    padding: 1rem 0;
  }
  span{
    padding: 1rem 0 0 0 ;
  }
  th{
    color: #FFF!important;
  }

  div.MuiPaper-root.MuiTableContainer-root {
    max-height: 500px;
  }
  
  `;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-around;
  
  button, a{
    background-color: transparent;
    border: none;
    cursor: pointer;
    height: 16px;
  }

  `;
export const ContainerHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content:flex-start;
  gap:1rem;
  flex-wrap: wrap;
  p {
    color: #232323;
    width: 100%;
    text-align:center;
  }
  /* border: 1px solid red; */
  `;

export const ContainerFilter = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 1rem;
  div {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 1rem;
    span {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: column;

    }
  }

`;
export const Box = styled.div`
  /* border: 1px solid var(1px solid rgba(34,36,38,.15)--color-primary); */
  padding: 2rem;
  border-radius: 1rem;
  background: ${props => props.color || "#222"};
  color: #FFF;
  width: 200px;
  height: 100px;
  p {
    font-size: 10px;
    padding: 0;
    margin: 0;
    font-weight: bold;
    color: #c6c6c6;
  }
`;
export const MainText = styled.h4`
  padding: 0;
  margin:0;
  font-size: ${props => props.isMinimal ? "18px!important" :"26px!important"};
  color:var(--color-primary);
  text-align:center;
`;

export const Input = styled.input`
  width: 100%;
  height: 35px;
  margin: 0;
  padding: 0.67857143em 1em;
  outline: 0;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  font-family: sans-serif;
  font-weight: 400;
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  -webkit-appearance: none;
  box-shadow: 0 0 0 0 transparent inset;
  transition: color 0.1s ease, border-color 0.1s ease;
  `;

export const ButtonReset = styled.button`
  padding: 0.67857143em 1em;
  height: 35px;

  transition: color 0.1s ease, border-color 0.1s ease;
  box-shadow: 0 0 0 0 transparent inset;
  background: var(--color-primary);
  color: #FFF;
  border: none;
  cursor:pointer;
  border-radius: 10px;
  &:hover{
    background: var(--color-primary-dark);
  }

`;
export const SemanticLoader = styled(Loader)`

`;
export const Accordion = styled.div`
  display: flex;
  align-items:end;
  justify-content: flex-start;
  flex-direction:column;

`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .5rem 1rem;
  border: 1px solid #c6c6c6;
  gap: 1rem;
  width: 100%;
  transition: var(--transition);
  background:#282828;
  border-radius:5px;
  color: #fff;
  p {
    padding:0;
    margin:0;
    text-align: left;
    &:first-of-type {
      width: 500px;  
    }
  }
  p.title {
    font-weight: bold;
  }
  &:hover{
    cursor: pointer;
  }
  `;
export const ModuloContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  border: 1px solid #c6c6c6;
  background:#484848;
  padding: .5rem 1rem;
  border-radius:5px;

  gap: 1rem;
  width: 100%;
  color: #fff;
  transition: var(--transition);
  p {
    padding:0;
    margin:0;
    text-align: left;
    &:first-of-type {
      width: 500px;  
    }
  }
  p.title {
    font-weight: bold;
  }
  &:hover{
    cursor: pointer;
  }
  `;
export const CourseData = styled.div`
  display: grid;
  grid-template-columns: 4fr 1fr 1fr;
  padding: .5rem 1rem;
  border: 1px solid #c6c6c6;
  gap: 1rem;
  width: 97%;
  border-radius:5px;

  transition: var(--transition);
  p {
    padding:0;
    margin:0;
    text-align: left;

    &:last-of-type {
      justify-self : flex-end;
      justify-content: flex-end;
      align-self: flex-end;
    }

  }
  p.title {
    font-weight: bold;
  }
  &:hover{
    cursor: pointer;
    background: #c6c6c6;
  }
`;
export const ContainerOfContents = styled.div`
  max-height: 500px;
  overflow-y: auto;

`;
export const ContainerSubtitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  width: fit-content;
  height: fit-content;
  padding: 0 0 .5rem 0;

  span{
    width: fit-content;
    padding:0;
    margin:0;
  }

  div {
    width: 10px;
    height: 10px;
    border-radius: 2px;
    align-self: center;

  }
`;

export const SendDocumentation = styled.button`
  padding: .5rem;
  background: var(--color-primary);
  border: 1px solid #FFF;
  border-radius: 5px;
  cursor: pointer;
  transition: var(--transition);
  color: #FFF;
  &:hover{
    background: var(--color-primary-dark);
  }
`;
export const Profile = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content:flex-start;
  margin-bottom: 1rem;
  gap: 1rem;
  width: 100%;
  height: 100%;
  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 1px solid var(--color-primary);
    object-fit: cover;
  }
  div.wrapper {
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;
    gap: 10px;
    padding: .5rem;
  }
`;

export const WrapperInner = styled.div`
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  display: flex;
  border-radius: 5px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  padding: .2rem .5rem;
  border: 1px solid #c6c6c6;
  p {
    width: 100%;
    strong {
      font-weight: 600;
      margin-right:.2rem;
    }
    span {
      color: red;
    }

  }
  p.title-p {
    text-align:center;
    font-size: 14px;
    font-weight: bold;
  }
`;
export const InputTextArea = styled.input`
  width: 100%;
  height: 200px;
  padding: .5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f9f9f9;
  font-size: 1rem;
  color: #333;
  resize: vertical;

  &:focus {
    border-color: #66afe9;
    outline: none;
    box-shadow: 0 0 8px rgba(102, 175, 233, 0.6);
  }

  &::placeholder {
    color: #999;
  }

`;